module.exports = __webpack_public_path__ + "static/media/chongoni_text_01.00bc6061.jpg";